// Formato en español de México: montos, fechas y tiempos relativos.

export function mxn(n: number | string | null | undefined, decimales = 0): string {
  const v = Number(n ?? 0);
  return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: decimales, minimumFractionDigits: decimales }).format(Number.isFinite(v) ? v : 0);
}

export function num(n: number | string | null | undefined): string {
  const v = Number(n ?? 0);
  return new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 }).format(Number.isFinite(v) ? v : 0);
}

/** «8 sep 2026» a partir de un ISO (fecha o fecha-hora). */
export function fechaCorta(iso: string | Date | null | undefined): string {
  if (!iso) return "";
  const d = typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T12:00:00`) : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("es-MX", { day: "numeric", month: "short", year: "numeric", timeZone: "America/Monterrey" }).format(d).replace(".", "");
}

export function fechaHora(iso: string | Date | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("es-MX", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "America/Monterrey" }).format(d).replace(".", "");
}

/** «hace 3 días», «hoy», «en 2 días». */
export function relativo(iso: string | Date | null | undefined, ahora = new Date()): string {
  if (!iso) return "";
  const d = typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T12:00:00`) : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const ms = d.getTime() - ahora.getTime();
  const dias = Math.round(ms / 86_400_000);
  const horas = Math.round(ms / 3_600_000);
  const minutos = Math.round(ms / 60_000);
  if (Math.abs(minutos) < 1) return "ahora";
  if (Math.abs(minutos) < 60) return minutos < 0 ? `hace ${-minutos} min` : `en ${minutos} min`;
  if (Math.abs(horas) < 24 && Math.abs(dias) < 1) return horas < 0 ? `hace ${-horas} h` : `en ${horas} h`;
  if (dias === 0) return "hoy";
  if (dias === -1) return "ayer";
  if (dias === 1) return "mañana";
  if (dias < 0) return `hace ${-dias} días`;
  return `en ${dias} días`;
}

/** Fecha ISO (AAAA-MM-DD) de hoy en Saltillo, o desplazada N días. */
export function hoyIso(mas = 0): string {
  const d = new Date(Date.now() + mas * 86_400_000);
  return new Intl.DateTimeFormat("en-CA", { timeZone: "America/Monterrey", year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
}

export function duracion(segundos: number): string {
  const s = Math.max(0, Math.round(segundos));
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m < 60) return r ? `${m} min ${r} s` : `${m} min`;
  const h = Math.floor(m / 60);
  return `${h} h ${m % 60} min`;
}

export function pct(n: number | null | undefined): string {
  return n == null ? "—" : `${Math.round(n)} %`;
}

export function iniciales(nombre: string): string {
  return nombre
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0] ?? "")
    .join("")
    .toUpperCase();
}
